import { IPageResultDto, IResponseBaseTDto, ISearchBaseDto } from "@sprytki-frontend-apps/common";
import { IGateEventDto } from "api/interfaces/events";
import { apiClient } from "./apiClient";

const GATES = 'gates'

export const GateServiceAPI = {
	open: async (id: string): Promise<IResponseBaseTDto<boolean>> => {
		const response = await apiClient.post(`${GATES}/${id}/open`);
		return response.data;
	},
	getEvents: async (
		id: string,
		search: ISearchBaseDto
	): Promise<IResponseBaseTDto<IPageResultDto<IGateEventDto>>> => {
		const response = await apiClient.post(`${GATES}/${id}/events`, search);
		return response.data;
	},
}
